import React from 'react'
import { Trans } from '@lingui/react/macro'


import { tw, cls } from 'tagged-classnames-free';
export interface IBannerProps {
  className?: string
  children?: React.ReactNode
}

const Banner: React.FC<IBannerProps> = (props) => {
  const { className, children } = props

  return (
    <div
      className={tw`
        relative
        px-4 py-10 md:pt-12
        ${className}
      `}
    >
      <div
        className={cls`
          relative
          mx-auto
          text-center
        `}
      >
        <h1
          className={cls`
            mx-auto mb-3
            max-w-[913px] text-center text-2xl
            font-bold md:text-3xl lg:text-5xl
          `}
        >
          <Trans>Plans & Pricing</Trans>
        </h1>
        {children}
      </div>
    </div>
  )
}

export default Banner
